/* ©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved.
 */
// Import PolymerElement class
import {
    PolymerElement,
    html
} from "@polymer/polymer/polymer-element.js";
import {
    mixinBehaviors
} from "@polymer/polymer/lib/legacy/class.js"; // define the element's class element

class profileContactDetailsAddressTab extends mixinBehaviors([accessibilityBehaviours.commonFunctions,corpBehaviours.appCommonBehaviour], PolymerElement) {
    static get template() {
        return html`
             
              <style  include="app-styles">  
                div[preferredBackground]{
                  background: var(--brand-color);
                } 
                div[preferredLabel]{
                  color: var(--primary-light-color);
                } 
                div[preferredContactAddress]{
                  color: var(--secondary-light-color);
                } 
                paper-icon-button[preferredIcon]{
                  color: var(--primary-light-color);
                }
                .paddingTop4{
                  padding-top:4%;
                }
                .EditButtonWidth{
                  width: calc(25% - 8px) !important;
                }
                .ironListNoXScroll{
                  overflow-x:hidden;
                  overflow-y:hidden;
                }
                paper-icon-button[aria-label="Back"][phone]{
                  left:5px;
              }
             </style>
             <!--AJAX call to fetch details of address -->
               <oe-ajax id="addressFetch" url="/api/CBUsers/{{userId}}/personaldetails" on-response="addressAjaxResponse" on-error="adressListError"></oe-ajax> 
              <div class="mdl-grid padding-b-zero"></div>
                <iron-list class="ironListNoXScroll listing-1" items="{{addressTypes}}" role="list" id="address-ironlist">
                  <template>
                  <div class="margin-b-zero margin-t-zero mdl-cell mdl-cell--12-col padding-b-zero padding-t-zero">
                    <div role="listitem" aria-selected="undefined" aria-readonly="true" preferredBackground$="{{item.preferredAddress}}" id="phone_background_{{index}}" class="margin-b-zero mdl-cell border-1px border-round-8px mdl-cell--4-col-phone mdl-cell--8-col-tablet mdl-cell--12-col padding-zero">
                      <div class="mdl-grid padding-r-zero">
                        <div class="outlineOffset margin-b-zero margin-l-zero margin-t-zero mdl-cell mdl-cell--3-col-phone mdl-cell--6-col-tablet mdl-cell--9-col" id="focused-div" tabindex=0>
                          <div preferredLabel$="{{item.preferredAddress}}" id="phone_label_{{index}}" class="mdl-cell mdl-cell--4-col-phone mdl-cell--8-col-tablet mdl-cell--12-col font-size-m">
                            <oe-i18n-msg id="addressHeading" msgid="{{item.label}}"></oe-i18n-msg>
                          </div>
                          <div preferredContactAddress$="{{item.preferredAddress}}" id="phone_number_{{index}}" class="mdl-cell mdl-cell--4-col-phone mdl-cell--8-col-tablet mdl-cell--12-col secondary-dark-text-s">
                            <template is="dom-if" if="{{item.isAddressPresent}}">
                              <div class="text-overflow-ellipsis" id="addressLine1">{{item.addressDetails.houseNumber}}<template is="dom-if" if="{{item.addressDetails.buildingLevel}}">,&nbsp;</template>{{item.addressDetails.buildingLevel}}<template is="dom-if" if="{{item.addressDetails.streetNumber}}">,&nbsp;</template>{{item.addressDetails.streetNumber}}</div>
                              <div class="text-overflow-ellipsis" id="addressLine2">{{item.addressDetails.streetName}}<template is="dom-if" if="{{item.addressDetails.suburb}}">,&nbsp;</template>{{item.addressDetails.suburb}}<template is="dom-if" if="{{item.addressDetails.locality}}">,&nbsp;</template>{{item.addressDetails.locality}}<template is="dom-if" if="{{item.addressDetails.town}}">,&nbsp;</template>{{item.addressDetails.town}}</div>
                              <div class="text-overflow-ellipsis" id="addressLine3">{{item.addressDetails.cityDesc}}<template is="dom-if" if="{{item.addressDetails.state.stateDescription}}">,&nbsp;</template>{{item.addressDetails.state.stateDescription}}<template is="dom-if" if="{{item.addressDetails.cityDesc}}">,&nbsp;</template>{{item.addressDetails.zipCode}}</div>
                              <div class="text-overflow-ellipsis" id="addressLine4">{{item.addressDetails.country.codeDescription}}</div>
                            </template>
                            <template is="dom-if" if="{{!item.isAddressPresent}}">
                              <oe-i18n-msg id="NoRecordMsg" msgid="{{item.notFoundLabel}}"></oe-i18n-msg>
                            </template>
                          </div>
                        </div>
                        <template is="dom-if" if="{{item.isAddressPresent}}">
                          <div class="EditButtonWidth margin-r-zero margin-t-zero mdl-cell mdl-cell--1-col-phone mdl-cell--2-col-tablet mdl-cell--3-col secondary-dark-text-s text-align-right">
                            <paper-icon-button class="iron-icon-style-m" preferredIcon$="{{item.preferredAddress}}" id="address_edit_icon_{{index}}" icon="pencil"  on-keydown="setFocus"on-tap="modifyAddress" aria-label$="{{item.editAriaLabel}}"></paper-icon-button>
                          </div>
                        </template>
                        <template is="dom-if" if="{{!item.isAddressPresent}}">
                          <div class="paddingTop4 mdl-cell mdl-cell--1-col-phone mdl-cell--2-col-tablet mdl-cell--3-col secondary-dark-text-s text-align-right">
                            <div preferredAddIcon$="{{item.preferredContact}}" id="phone_add_button" role="button" on-tap="addAddress" on-keydown="setFocus" aria-label$="{{item.addAriaLabel}}" class="outlineOffset cursor-pointer text-brand-color flat-button" tabindex="0">
                              <oe-i18n-msg msgid="b_AddWithPlusSign"></oe-i18n-msg>
                            </div>
                          </div>
                        </template>
                      </div>
                    </div>
                  </div>
                  </template>
                </iron-list>
                
              `;
  }

  static get properties() {
    return {
      //types of addresses
      addressTypes: {
        type: Array,
        value: [{
          "addressType": "Mailing",
          "aType": "communicationAddressDetails",
          "tempFlag": true,
          "updateScenario": false,
          "addAriaLabel": getLabel('m_AddCommunicationAddress'),
          "editAriaLabel": getLabel('m_EditCommunicationAddress')
        }, {
          "addressType": "Home",
          "aType": "homeAddressDetails",
          "tempFlag": true,
          "updateScenario": false,
          "addAriaLabel": getLabel('m_AddResedentialAddress'),
          "editAriaLabel": getLabel('m_EditResedentialAddress')
        }, {
          "addressType": "WORK",
          "aType": "workAddressDetails",
          "tempFlag": true,
          "updateScenario": false,
          "addAriaLabel": getLabel('m_AddOfficeAddress'),
          "editAriaLabel": getLabel('m_EditOfficeAddress')
        }]
      },
      //all addresses
      addressDetails: {
        type: Array,
        notify: true
      },
      //logged in user
      userId: {
        type: String,
        notify: true
      },
      //counter to change iron page
      myprofilepagenumber: {
        type: Number,
        notify: true
      },
      //selected address s detail
      selectedAddressDetail: {
        type: Object,
        notify: true
      },
      personalDetails: {
        type: Array,
        notify: true,
        observer: "addressResponse"
      },
      fromEditPage: {
        type: Boolean,
        notify: true,
        observer: "checkBooleanValue"
      },
      personalDetailsResponse: {
        type: Array,
        notify: true
      }

    };
  }
  checkBooleanValue() {
    if (this.fromEditPage) {
      this.$$("#addressFetch").generateRequest();
      this.fromEditPage = false;
    }
  }

  addressAjaxResponse(e) {
    var response = e.detail.response;
    this.personalDetails = response;
    this.personalDetailsResponse = response;
    this._refreshAddressDetails();
  }

  _refreshAddressDetails() {
    var temp = _.cloneDeep(this.addressTypes);
    this.addressTypes = [];
    this.addressTypes = temp;
    var ironList = this.$$("#address-ironlist");
    ironList.__data.items = this.addressTypes;
    if (ironList) {
      ironList._render();
    }

  }
  connectedCallback() {
    super.connectedCallback();
   // this.$$("#addressFetch").generateRequest();
    this.getAddressTypes();
  } //Method to get all type of addresses


  getAddressTypes() {
    for (let i = 0; i < this.addressTypes.length; i++) {
      this.addressTypes[i].isAddressPresent = false;
      this.addressTypes[i].preferredAddress = false;
      if (this.addressTypes[i].addressType == "Mailing") {
        this.addressTypes[i].label = "l_CommunicationAdd";
        this.addressTypes[i].notFoundLabel = "l_CommunicationAddressNotFound"
      } else if (this.addressTypes[i].addressType == "Home") {
        this.addressTypes[i].label = "l_homeAddress";
        this.addressTypes[i].notFoundLabel = "l_homeAddressNotFound"
      } else if (this.addressTypes[i].addressType == "WORK") {
        this.addressTypes[i].label = "l_OfficeAddress";
        this.addressTypes[i].notFoundLabel = "l_OfficeAddressNotFound"

      }
    }
  } //success method for details api call


  addressResponse() {
    this.addressDetails = [];
    this.addressDetails.push(this.personalDetails);
    if (this.addressDetails != undefined) {
      this.getAddressDetails();
    }
    this.fire('stop-processing-loader');
  } //map the address details


  getAddressDetails() {
    var contactDetails = [];
    for (let i = 0; i < this.addressDetails[0].contactAddress.length; i++) {
      contactDetails.push(this.addressDetails[0].contactAddress[i]);
    }
    for (let i = 0; i < this.addressTypes.length; i++) {
      for (let j = 0; j < contactDetails.length; j++) {
        if (this.addressTypes[i].addressType == contactDetails[j].addressType) {
          if (contactDetails[j].preferredAddress.cmCode == "Y") {
            this.addressTypes[i].alwaysPreferred = true;
            this.addressTypes[i].preferredAddress = true;
            this.addressTypes[i].preferedAddressType = this.addressTypes[i].addressType
          }
          else {
            this.addressTypes[i].alwaysPreferred = false;
            this.addressTypes[i].preferredAddress = false;
            this.addressTypes[i].preferedAddressType = "";
          }
          this.addressTypes[i].addressId = contactDetails[j].addressId;
          this.addressTypes[i].addressDetails = contactDetails[j].addressDetails;
          this.addressTypes[i].originalAddress = _.cloneDeep(contactDetails[j].addressDetails);
          this.addressTypes[i].state = contactDetails[j].addressDetails.state;
          this.addressTypes[i].isAddressPresent = true;
          this.addressTypes[i].updateScenario = true;
        }
      }
    }
  } //on click of edit button


  modifyAddress(event) {
    var data = event.model.item;
    this.selectedAddressDetail = _.cloneDeep(data);
    this.myprofilepagenumber = 9;
  } //on click of add button


  addAddress(event) {
    var data = event.model.item;
    data.addressDetails = {};
    this.selectedAddressDetail = _.cloneDeep(data);
    this.myprofilepagenumber = 9;
  }

  setFocus(event) {
    for (let i = 0; i < this.addressTypes.length; i++) {
      if (event.model.__data.index == this.addressTypes.length - 1) {
        if (!event.shiftKey && (event.keyCode === 9 || KeyboardEvent.charCode == 9 || KeyboardEvent.keyCode == 9 || event.which == 9)) {
          this.shadowRoot.querySelector("#focused-div").focus();
        }
      }
    }
  }

} // Associate the new class with an element name


customElements.define('profile-contact-details-address-tab', profileContactDetailsAddressTab);